export default __webpack_public_path__ + "static/the-core-collection-banner-desktop-cdfddc519eae29ac29eb82293e5a20d4.webp";